import React, { useCallback, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  Modal,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MedicineType from "./medicine-type";
import AddIcon from "@mui/icons-material/Add";
import MedicineScheduleForm from "../../../Modals/delete-modal/medicine-schedule-modal";
import MedicineAdministrationModal from "../../../Modals/adm-route-modal";
import Loader from "../../../loader/loader";
import debounce from "lodash.debounce";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { getApiErrorMessage } from '../../../../utils/apiError';

interface MedicineForm {
  selectedRowData: any;
  onSubmit: () => void;
}

interface FormData {
  medicineName: string;
  medicineUnit: string;
  strength: string;
  medicineTypeId: string;
  companyName: string;
  genericId: string;
  routAdministrationId: string;
  unit: string;
  duration: string;
  dosage: any;
  durationUnit: string;
  frequency: {
    urdu_notation: string;
    math_notation: string;
    eng_notation: string;
    abr_notation: string;
  };
  allDosageNotations: {
    eng_notation: string,
    med_notation: string,
    urdu_notation: string,
  },
  note: string;
}

const MedicineForm: React.FC<MedicineForm> = ({
  selectedRowData,
  onSubmit,
}) => {
  const [formData, setFormData] = useState<FormData>({
    medicineName: "",
    routAdministrationId: "",
    medicineUnit: "",
    strength: "",
    medicineTypeId: "",
    companyName: "",
    genericId: "",
    dosage: "",
    unit: "",
    duration: "1",
    durationUnit: "Days",
    frequency: {
      urdu_notation: "",
      math_notation: "",
      eng_notation: "",
      abr_notation: "",
    },
    allDosageNotations: {
      eng_notation: "",
      med_notation: "",
      urdu_notation: "",
    },
    note: "",
  });
  const [medicineType, setmedicineType] = useState<any>();
  const [generic, setGeneric] = useState<any>();
  const [unit, setUnit] = useState<any>();
  const [frequency, setFrequency] = useState([]); // Initialize as an empty array or appropriate initial value
  const [selectedMedicineTypeId, setSelectedMedicineTypeId] =
    useState<string>("");
  const [selectedMedicineTypeName, setSelectedMedicineTypeName] =
    useState<string>("");
  const [dataExists, setDataExists] = useState(false);
  const [routeAdm, setRouteAdm] = useState<any>();
  const [typeAbr, setTypeAbr] = useState("");
  const [inputValue, setInputValue] = React.useState("");
  const [inputunit, setInputUnit] = React.useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [showTypeForm, setShowTypeForm] = useState(false);
  const [openFreq, setOpenFreq] = useState<boolean>(false);
  const [openRoute, setOpenRoute] = useState<boolean>(false);
  const [loading, setloading] = useState(false);
  const [searchGeneric, setSearchGeneric] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState('');
  const [openDosage, setOpenDosage] = useState<boolean>(false);
  const [allDosage, setAllDosage] = useState<any[]>([]);
  const [formdata, setFormdata] = useState({
    med_notation: "",
    eng_notation: "",
    urdu_notation: "",
  });

  const handleChangeDosage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormdata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmitDosage = async () => {
    const med_notation = formdata?.med_notation?.trim();
    const eng_notation = formdata?.eng_notation?.trim();
    const urdu_notation = formdata?.urdu_notation?.trim();

    if (!med_notation || !eng_notation || !urdu_notation) {
      toast.error("Please fill Med, Eng, and Urdu notation");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_OPD_API_URL}/dosage/addDosage`,
        {
          med_notation,
          eng_notation,
          urdu_notation,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (!response?.data?.isSuccess) {
        toast.error(response?.data?.message || "Failed to add dosage");
      } else {
        toast.success(response?.data?.message || "Dosage added successfully");
        setFormdata({
          med_notation: "",
          eng_notation: "",
          urdu_notation: "",
        });
        handleCloseDosage()
      }
    } catch (error: any) {
      toast.error(getApiErrorMessage(error, "Failed to add dosage"));
    }

  };
  const debouncedSearch = debounce((value) => {
    getmedicineTypeId(value);
  }, 500);
  const handleInputChangeMedicineType = (event: any) => {
    const value = event.target.value;
    debouncedSearch(value);
    // getmedicineTypeId(value)
  };

  const handleInputChangeMedicineTypeBlur = () => {
    debouncedSearch("");
    // getmedicineTypeId(value)
  };
  const handleCloseDosage = () => {
    setOpenDosage(false)
    getAllDosage()
  };

  const handleCloseFreq = () => {
    setOpenFreq(false);
    getSchedule();
  };
  const handleCloseRoute = () => {
    setOpenRoute(false);
    getRouteAdm();
  };

  const handleOpenModal = () => {
    setModalOpen(true);
    setShowTypeForm(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const getSchedule = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_OPD_API_URL}/dosage-schedules/getAllByPagination`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            count: 50000,
            pageNo: 1,
          },
        }
      );
      setFrequency(response.data?.data);
    } catch (error) {
      console.error("Error fetching schedule:", error);
    }
  };

  useEffect(() => {
    if (selectedRowData) {
      // setFormData(selectedRowData);
      setFormData((prevData: any) => ({
        ...prevData,
        medicineName: selectedRowData?.medicineName,
        medicineUnit: selectedRowData?.medicineUnit ? selectedRowData?.medicineUnit : '',
        strength: selectedRowData?.strength,
        medicineTypeId: selectedRowData?.medicineTypeId?._id,
        routAdministrationId: selectedRowData?.routAdministrationId,
        companyName: selectedRowData?.companyName,
        genericId: selectedRowData?.genericId?._id,
        unit: selectedRowData?.unit,
        duration: selectedRowData?.duration,
        durationUnit: selectedRowData?.durationUnit,
        frequency: selectedRowData?.frequency,
        note: selectedRowData?.note,
        dosage: selectedRowData?.dosage, 
        allDosageNotations: selectedRowData?.allDosageNotations,
      }));
      setSelectedMedicineTypeId(selectedRowData?.medicineTypeId?._id);
      setDataExists(true);
    }
  }, [selectedRowData]);

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    // const parsedValue =
    //   name === "strength" ? Math.max(0, parseFloat(value)) : value;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "medicineTypeId") {
      setSelectedMedicineTypeId(value as string);
      setUnit([]);
      getUnitsByMedicineTypeId(value);
    }
  };

  const handleShortCourseChange = (
    e: { target: { name: any; value: any } } | any
  ) => {
    const name = e.target ? e.target.name : e.name;
    const value = e.target ? e.target.value : e.value;

    if (name === "unit") {
      const parsedValue = Math.max(0, parseInt(value, 10));
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: parsedValue.toString(),
      }));
    } else if (name === "frequency") {
      if (value) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          frequency: {
            urdu_notation: value.urdu_notation || "",
            math_notation: value.math_notation || "",
            eng_notation: value.eng_notation || "",
            abr_notation: value.abr_notation || "",
          },
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          frequency: {
            urdu_notation: "",
            math_notation: "",
            eng_notation: "",
            abr_notation: "",
          },
        }));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const getRouteAdm = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_OPD_API_URL}/routes-of-administration/getAllByPagination`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          count: 50000,
          pageNo: 1,
        },
      }
    );
    setRouteAdm(response.data?.data);
  };

  const debouncedGetGeneric = useCallback(
    debounce(async (search: string) => {
      const response = await axios.get(
        `${process.env.REACT_APP_OPD_API_URL}/generic/getAllSelectAbleGeneric?search=${search}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          // params: {
          //   count: 50000,
          //   pageNo: 1,
          // },
        }
      );
      setGeneric(response.data?.data);
    }, 500),
    []
  );
  useEffect(() => {
    debouncedGetGeneric(searchGeneric);
  }, [debouncedGetGeneric, searchGeneric]);

  const getUnitsByMedicineTypeId = async (medicineTypeId: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_OPD_API_URL}/medicinetype/getById/${medicineTypeId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const units = response.data?.data?.units || [];
      setUnit(units);
      // Set default unit if units are available
      if (units.length > 0) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          medicineUnit: units[0], // Set the default unit
        }));
      }
    } catch (error) {
      console.error("Error fetching units:", error);
      toast.error("Failed to load units");
    }
  };

  useEffect(() => {
    const medicineTypesName = medicineType?.find(
      (mt: any) => mt?._id === selectedMedicineTypeId
    );
    setSelectedMedicineTypeName(medicineTypesName?.medicineTypeName);
    setTypeAbr(medicineTypesName?.medicineTypeAbrivation || "");
  }, [selectedMedicineTypeId]);

  useEffect(() => {
    setFormData((prevdata) => ({
      ...prevdata,
      medicineUnit: inputunit,
    }));
  }, [inputunit]);

  const getmedicineTypeId = async (search: string) => {
    const response = await axios.get(
      `${process.env.REACT_APP_OPD_API_URL}/medicineType/getAll`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          count: 50000,
          pageNo: 1,
          search: search,
        },
      }
    );
    const fetchedMedicineType = response?.data?.data || [];
    const uniqueMedicineType = Array.from(
      new Map(fetchedMedicineType?.map((item: any) => [item?.medicineTypeName, item]))?.values()
    );
    setmedicineType(uniqueMedicineType);
  };

  const resetForm = () => {
    setFormData({
      medicineName: "",
      medicineUnit: "",
      strength: "",
      medicineTypeId: "",
      routAdministrationId: "",
      companyName: "",
      genericId: "",
      unit: "",
      duration: "",
      dosage: "",
      durationUnit: "Days",
      frequency: {
        urdu_notation: "",
        math_notation: "",
        eng_notation: "",
        abr_notation: "",
      },
      allDosageNotations: {
        eng_notation: "",
        med_notation: "",
        urdu_notation: "",
      },
      note: "",
    });
  };

  useEffect(() => {
    debouncedSearch(searchTerm);
  }, [modalOpen, searchTerm]);

  useEffect(() => {
    // getGeneric();
    if (selectedMedicineTypeId && !selectedRowData) {
      getUnitsByMedicineTypeId(selectedMedicineTypeId);
    }
    if (selectedRowData) {
      setFormData((prevData) => ({
        ...prevData,
        medicineUnit: selectedRowData.medicineUnit,
      }))
    }
  }, [selectedMedicineTypeId]);

  // useEffect(() => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     medicineUnit: selectedRowData.medicineUnit,
  //   }));
  // }, [selectedRowData]);
  useEffect(() => {
    getRouteAdm();
  }, [openRoute]);
  useEffect(() => {
    getSchedule();
  }, [openFreq]);
  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const medicineName = formData.medicineName?.trim();
    if (!medicineName) {
      toast.error("Medicine name is required");
      return;
    }
    if (!formData.medicineTypeId) {
      toast.error("Medicine type is required");
      return;
    }

    setloading(true);
    try {
      let updatedFormData = {
        ...formData,
        medicineName,
      };
      if (typeAbr) {
        updatedFormData.medicineName = `${typeAbr}-${medicineName}`;
      }
      let response;
      if (selectedRowData && dataExists) {
        response = await axios.patch(
          `${process.env.REACT_APP_OPD_API_URL}/medicine/updateById/${selectedRowData?._id}`,
          { ...formData, medicineName },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_OPD_API_URL}/medicine/createMedicine`,
          updatedFormData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }

      if (response.data?.isSuccess === false) {
        toast.error(response.data?.message || "Failed to save medicine");
      } else {
        toast.success(response.data?.message || "Medicine saved successfully");
        onSubmit();
        resetForm();
        setDataExists(false);
      }
    } catch (error: any) {
      toast.error(getApiErrorMessage(error, "Failed to save medicine"));
    } finally {
      setloading(false);
    }
  };

  const getAllDosage = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_OPD_API_URL}/dosage/getAllBySearch`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      })
      setAllDosage(response?.data?.data)
    } catch (err) {
      console.error("Failed to fetch dosages", err);
    }
  }
  useEffect(() => {
    getAllDosage()
  }, [])
  const handleCreateNewGeneric = async (inputValue: string) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_OPD_API_URL}/generic/createGeneric`,
        { genericName: inputValue },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const newGeneric = response?.data?.data;
      if (newGeneric) {
        // setGeneric((prevGenerics: any) => [...prevGenerics, newGeneric]);
        setGeneric((prevGenerics: any) => [
          ...(Array.isArray(prevGenerics) ? prevGenerics : []),
          newGeneric
        ]);
        setFormData((prevFormData) => ({
          ...prevFormData,
          genericId: newGeneric?._id,
        }));
        toast.success(
          `New generic "${newGeneric?.genericName}" added successfully`
        );
      } else {
        toast.error("Failed to create new generic");
      }
    } catch (error) {
      console.error("Error creating new generic:", error);
      toast.error("Failed to create new generic");
    }
  };

  const handleInputChange = (
    event: any,
    newInputValue: React.SetStateAction<string>
  ) => {
    setInputValue(newInputValue);
    setSearchGeneric(newInputValue);
  };

  const handleInputChangeBlur = () => {
    setInputValue("");
    setSearchGeneric("");
  };

  const handleAddButtonClick = () => {
    if (inputValue.trim() !== "") {
      handleCreateNewGeneric(inputValue);
      setInputValue("");
    }
  };

  const handleKeyPress = (event: {
    key: string;
    preventDefault: () => void;
  }) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default behavior of form submission
      handleAddButtonClick();
    }
  };

  return (
    <Box
      sx={{
        background: "#fff",
        p: 2,
        borderRadius: "8px",
        maxHeight: { md: "78vh", sm: "100%", xs: "100%" },
        overflowY: "auto",
        position: "relative",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#077DD3",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "rgba(7, 125, 211, 0.24)",
        },
      }}
    >
      <form onSubmit={handleSubmit}>
        <Grid container spacing={1.5}>
          <Grid item md={6} xs={6} sm={6}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Medicine Type :
            </Typography>
            <Autocomplete
              options={medicineType || []}
              size="small"
              getOptionLabel={(option: any) => option?.medicineTypeName}
              value={
                medicineType?.find(
                  (type: any) => type?._id === formData?.medicineTypeId
                ) || null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  handleChange({
                    target: {
                      name: "medicineTypeId",
                      value: newValue?._id,
                    },
                  });
                }
              }}
              // filterOptions={(options) => {
              //   const filteredOptions = options?.filter((option) =>
              //     option?.medicineTypeName?.toLowerCase().includes(searchTerm.toLowerCase())
              //   );
              //   return filteredOptions;
              // }}

              renderInput={(params: any) => (
                <TextField
                  {...params}
                  placeholder="Medicine Type"
                  variant="outlined"
                  // size="small"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {params.InputProps.endAdornment}
                        <AddIcon
                          onClick={handleOpenModal}
                          sx={{
                            background: "#FFFFFF",
                            color: "#055FFC",
                            borderRadius: "50%",
                            p: 0.5,
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                        />
                      </React.Fragment>
                    ),
                  }}
                  className="search-field"
                  onChange={handleInputChangeMedicineType} // Add this line
                  onBlur={handleInputChangeMedicineTypeBlur} // Add this line
                />
              )}
            />
          </Grid>
          <Grid item md={6} xs={6} sm={6}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Company Name :
            </Typography>
            <TextField
              size="small"
              placeholder="Company Name"
              fullWidth
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              className="search-field"
            />
          </Grid>
          <Grid item md={3} sm={3} xs={2}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Abr :
            </Typography>
            <TextField
              size="small"
              placeholder="ABR"
              fullWidth
              value={typeAbr}
              disabled
              className="search-field"
            />
          </Grid>
          <Grid item md={9} sm={6} xs={10}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Medicine Name :
            </Typography>
            <TextField
              size="small"
              placeholder="Medicine Name"
              fullWidth
              name="medicineName"
              required
              value={formData.medicineName}
              onChange={handleChange}
              className="search-field"
            />
          </Grid>

          <Grid item md={6} xs={6} sm={6}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Strength :
            </Typography>
            <TextField
              size="small"
              placeholder="Strength"
              fullWidth
              name="strength"
              value={formData.strength}
              onChange={handleChange}
              className="search-field"
            />
          </Grid>

          <Grid item xs={6}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Units :
            </Typography>

            <Autocomplete
              fullWidth
              size="small"
              options={unit || []}
              getOptionLabel={(option) => option || ""}
              value={formData.medicineUnit}
              onChange={(event, newValue) => {
                handleChange({
                  target: {
                    name: "medicineUnit",
                    value: newValue ? newValue : "",
                  },
                });
              }} 
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  placeholder="Unit"
                  value={inputunit}
                  onChange={(event) => setInputUnit(event.target.value)}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  className="search-field"
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={12}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Generic :
            </Typography>
            <Autocomplete
              fullWidth
              size="small"
              options={generic ?? []}
              getOptionLabel={(option) => option?.genericName}
              value={
                generic?.find(
                  (gen: any) => gen?._id === formData?.genericId
                ) || null
              }
              onChange={(event, newValue) => {
                handleChange({
                  target: {
                    name: "genericId",
                    value: newValue ? newValue._id : "",
                  },
                });
              }}
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  placeholder="Generic"
                  value={inputValue}
                  onChange={(event) =>
                    handleInputChange(event, event.target.value)
                  }
                  onBlur={handleInputChangeBlur}
                  onKeyPress={handleKeyPress}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {params.InputProps.endAdornment}

                        <AddIcon
                          sx={{
                            background: "#FFFFFF",
                            color: "#055FFC",
                            borderRadius: "50%",
                            p: 0.2,
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                          onClick={handleAddButtonClick}
                        />
                        {/* </Button> */}
                      </React.Fragment>
                    ),
                  }}
                  className="search-field"
                />
              )}
              filterOptions={(options, state) => {
                const searchGeneric = state.inputValue.toLowerCase();
                if (searchGeneric === "") {
                  // If search term is empty, show all medicines
                  return options;
                }
                // Filter based on search term
                return options?.filter((option) =>
                  option.genericName?.toLowerCase().includes(searchGeneric)
                );
              }}
            />
          </Grid>

          <Grid item md={6} sm={6} xs={6}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Dosage :
            </Typography>
            {/* <TextField
              size="small"
              placeholder="Dosage"
              fullWidth
              name="dosage"
              value={formData.dosage}
              onChange={handleShortCourseChange}
              className="search-field"
            /> */}
            <Autocomplete
              size="small"
              value={formData?.allDosageNotations?.med_notation ? formData?.allDosageNotations?.med_notation : formData?.dosage ? formData?.dosage : ''}
              onChange={(event, newValue) => {
                // Ensure newValue is a string, not an object
                if (newValue) {
                  const selectedDosage = allDosage?.find(
                    (schedule) => schedule?.med_notation === newValue
                  );
                  if (selectedDosage) {
                    setFormData({
                      ...formData,
                      allDosageNotations: {
                        eng_notation: selectedDosage.eng_notation,
                        med_notation: selectedDosage.med_notation,
                        urdu_notation: selectedDosage.urdu_notation,
                      },
                    });
                  }
                } else {
                  setFormData({
                    ...formData,
                    allDosageNotations: {
                      eng_notation: "",
                      med_notation: "",
                      urdu_notation: "",
                    },
                  });
                }
              }}
              options={
                allDosage
                  ? allDosage?.map((schedule) => schedule?.med_notation)
                  : []
              }
              getOptionLabel={(option) => option || ""}
              filterOptions={(options, { inputValue }) =>
                options.filter((option: any) =>
                  option?.toLowerCase()?.includes(inputValue.toLowerCase())
                )
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Dosage"
                  variant="outlined"
                  fullWidth
                  required
                  InputLabelProps={{ shrink: true }}
                  // onChange={(e: any) => setDefaultDosage(e.target.value)}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      dosage: e.target.value || undefined,
                    })
                  }
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {params.InputProps.endAdornment}
                        <AddIcon
                          onClick={() => setOpenDosage(true)}
                          sx={{
                            background: "#FFFFFF",
                            color: "#055FFC",
                            borderRadius: "50%",
                            p: 0.2,
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                        />
                      </React.Fragment>
                    ),
                  }}
                  className="search-field"
                />
              )}
            />
          </Grid>

          <Grid item md={6} sm={6} xs={6}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Freq :
            </Typography>
            <Autocomplete
              size="small"
              options={frequency || []}
              getOptionLabel={(option: any) => option?.abr_notation || ""} 
              value={
                frequency?.find(
                  (option: any) =>
                    option?.abr_notation === formData?.frequency?.abr_notation
                ) || null
              }
              onChange={(event, newValue) => {
                handleShortCourseChange({
                  target: {
                    name: "frequency",
                    value: newValue || {
                      urdu_notation: "",
                      math_notation: "",
                      eng_notation: "",
                      abr_notation: "",
                    },
                  },
                });
              }}
              filterOptions={(options, { inputValue }) => {
                const filteredOptions = options?.filter((option) =>
                  option.abr_notation.toLowerCase().includes(inputValue.toLowerCase())
                );
                return filteredOptions;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Freq"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {params.InputProps.endAdornment}
                        <AddIcon
                          onClick={() => setOpenFreq(true)}
                          sx={{
                            background: "#FFFFFF",
                            color: "#055FFC",
                            borderRadius: "50%",
                            p: 0.2,
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                        />
                      </React.Fragment>
                    ),
                  }}
                  className="search-field"
                />
              )}
            />
          </Grid>

          <Grid item md={7} sm={6} xs={6}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Route : <span style={{ fontSize: "8px" }}>(optional)</span>
            </Typography>

            <Autocomplete
              options={routeAdm || []} // Ensure options is always an array
              getOptionLabel={(option: any) => option?.RA_Abbreviation || ""} // Handle undefined option
              value={
                routeAdm?.find(
                  (r: any) => r?._id === formData?.routAdministrationId
                ) || null
              } // Handle undefined formData.routAdministrationId
              onChange={(event, newValue) => {
                // Handle the change event
                if (newValue) {
                  handleChange({
                    target: {
                      name: "routAdministrationId",
                      value: newValue._id,
                    },
                  });
                } else {
                  handleChange({
                    target: { name: "routAdministrationId", value: "" },
                  });
                }
              }}
              filterOptions={(options, { inputValue }) => {
                const filteredOptions = options?.filter((option) =>
                  option.RA_Abbreviation.toLowerCase().includes(inputValue.toLowerCase())
                );
                return filteredOptions;
              }}
              size="small"
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  placeholder="Route"
                  name="routAdministrationId"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {params.InputProps.endAdornment}
                        <AddIcon
                          onClick={() => setOpenRoute(true)}
                          sx={{
                            background: "#FFFFFF",
                            color: "#055FFC",
                            borderRadius: "50%",
                            p: 0.2,
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                        />
                      </React.Fragment>
                    ),
                  }}
                  className="search-field"
                />
              )}
            />
          </Grid>

          <Grid item sm={6} md={5} xs={6}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Duration :{" "}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                size="small"
                className="search-field"
                type="number"
                name="duration"
                value={formData.duration}
                onChange={handleShortCourseChange}
              />
              <FormControl
                size="small"
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    background: "#F5F5FB",
                    borderRadius: "12px",
                    // border: "1px solid #D8D8D8",
                    fontSize: "12px",
                  },
                }}
              >
                <Select
                  placeholder="Duration Type"
                  name="durationUnit"
                  value={formData.durationUnit}
                  onChange={handleShortCourseChange}
                  sx={{
                    borderRadius: "12px",
                    // border: "1px solid #D8D8D8",
                    background: "#F5F5FB",
                    fontSize: "12px",
                    boxShadow: "none", // Remove any default shadow that might look like a border
                    "& fieldset": {
                      // Target the fieldset for better border control
                      border: "none", // Remove default border if present
                    },
                  }}
                >
                  <MenuItem value="Days">Days</MenuItem>
                  <MenuItem value="Weeks">Weeks</MenuItem>
                  <MenuItem value="Hours">Hours</MenuItem>
                  <MenuItem value="Minutes">Minutes</MenuItem>
                  <MenuItem value="Months">Months</MenuItem>
                  <MenuItem value="Years">Years</MenuItem>
                  <MenuItem value="Lifetime">Lifetime</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={6} md={12}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
            >
              Note :{" "}
            </Typography>
            <TextField
              className="search-field"
              size="small"
              placeholder="Note"
              multiline
              fullWidth
              name="note"
              value={formData.note}
              onChange={handleShortCourseChange}
            />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          {loading ? (
            <Loader />
          ) : (
            <Button variant="contained" type="submit">
              Submit
            </Button>
          )}
        </Box>
      </form>
      {/* <MedicineTypeModal open={modalOpen} onClose={() => setModalOpen(false)} showTypeForm={showTypeForm}  /> */}

      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="xs"
      >
        <MedicineType
          onClose={() => setModalOpen(false)}
          showTypeForm={showTypeForm}
        />{" "}
        {/* Pass onClose to close the modal */}
      </Dialog>
      <Dialog
        open={openFreq}
        onClose={handleCloseFreq}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="xs"
      >
        <MedicineScheduleForm onClose={handleCloseFreq} />
      </Dialog>
      <Dialog
        open={openRoute}
        onClose={handleCloseRoute}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="xs"
      >
        <MedicineAdministrationModal onClose={handleCloseRoute} />
      </Dialog>
      <Dialog open={openDosage} onClose={handleCloseDosage} maxWidth='xs' fullWidth>
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: 2,
            p: 2,
            boxShadow: 1,
          }}
        >
          <Box display='flex' alignItems='center' justifyContent='space-between'>
            <Typography variant="h6" gutterBottom >
              Add Dosage
            </Typography>
            <IconButton>
              <CancelOutlinedIcon onClick={handleCloseDosage} />
            </IconButton>
          </Box>
          <TextField
            size="small"
            label="Med Notation"
            name="med_notation"
            value={formdata.med_notation}
            fullWidth
            onChange={handleChangeDosage}
            sx={{ mb: 2 }}
            className="search-field"
          />
          <TextField
            size="small"
            label="Eng Notation"
            name="eng_notation"
            value={formdata.eng_notation}
            fullWidth
            onChange={handleChangeDosage}
            sx={{ mb: 2 }}
            className="search-field"
          />
          <TextField
            size="small"
            label="Urdu Notation"
            name="urdu_notation"
            value={formdata.urdu_notation}
            fullWidth
            onChange={handleChangeDosage}
            sx={{ mb: 2, direction:'rtl' }}
            className="search-field"
            
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmitDosage}
            size="small"
          >
            Save
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
};

export default MedicineForm;
